import React from 'react';

const STEPS = [
  {
    num: "01",
    title: "Contact",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    ),
    description: (
      <>
        Easily connect with us to discuss your unique needs. Submit the contact form by filling the required fields. Call us directly at <a href="tel:+923177770002" className="highlight-contact">+92 (317) 777 0002</a> or email us at <a href="mailto:info@expertscommunication.net" className="highlight-contact">info@expertscommunication.net</a>.
        <br /><br />
        We'll get back to you within 24 hours.
      </>
    )
  },
  {
    num: "02",
    title: "Consultation",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    description: "Being a digital and leading IT company, first of all, we consult with you about the targets and opportunities. In this meeting, we understand your business goals and requirements. We also analyze your existing processes to pinpoint key areas that require strategic improvements and optimization to reach the targets."
  },
  {
    num: "03",
    title: "Strategy & Planning",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <line x1="9" y1="9" x2="15" y2="9" />
        <line x1="9" y1="13" x2="15" y2="13" />
        <line x1="9" y1="17" x2="13" y2="17" />
      </svg>
    ),
    description: "After the consultation, our team creates a custom plan according to your needs and business goals. At this stage, we develop a detailed strategy to clearly outline the most effective solutions for your organization. Then our team designs a comprehensive roadmap that has clearly defined timelines and important milestones to track progress."
  },
  {
    num: "04",
    title: "Efficient Rollout",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
      </svg>
    ),
    description: "Once your custom strategy is ready, we move into the launch phase. Our experienced team sets up the necessary systems and integrates functionalities with your project. We also train our team to handle your specific needs and test all systems thoroughly for effective working. Even after launch, we stay by your side with ongoing support and monitoring."
  }
];

function HowItWorks() {
  return (
    <section className="how-it-works-section">
      <div className="container">
        {/* Header Block */}
        <div className="how-it-works-header">
          <h2 className="how-it-works-title">
            How It Works At Our <span className="highlight-red">Leading BPO Company?</span>
          </h2>
          <p className="how-it-works-subtitle">
            Experts Communication believes in client satisfaction and quality services. As a leading BPO & IT company, we help many businesses in multiple industries to increase their revenue. We want to create a long-term and fruitful relationship with our clients to sustain their online growth, because we only believe in presenting results and growth. Our services maintain transparency with clients throughout the entire process. We're your reliable and trustworthy partner for every digital service you need.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="how-it-works-grid">
          {STEPS.map((step, idx) => (
            <div className="how-it-works-card" key={idx}>
              <div className="card-top">
                <span className="card-step-num">{step.num}</span>
                <div className="card-icon-container">
                  {step.icon}
                </div>
              </div>

              <div className="card-body">
                <h3 className="card-step-title">{step.title}</h3>
                <p className="card-step-desc">{step.description}</p>
              </div>

              {/* Progress Flow Connectors */}
              {idx < STEPS.length - 1 && (
                <div className="flow-indicator-line"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
